<template>
    <div>
        <Modal  id="egglack"
                v-model="modal1"
                @on-cancel="cancel"
                :closable="true"
                :styles="{top: '50px'}"
                :width="580">
            <div class="egglack" v-if="type === 1">
                <div> <!--恐龙蛋-->
                    <div class="title">
                        {{text}}
                    </div>
                    <div class="imgCon">
                  <span class="img">
                      <img src="../../images/egg/egg-l.png" alt="">
                  </span>
                    </div>
                    <div class="num">
                        {{balance}}
                    </div>
                    <div class="button">
                        <router-link :to="{name: 'myRecharge'}">
                            <span>立即购买</span>
                        </router-link>
                        <router-link :to="{name: 'myQuestionDetail',params:{code:'egg-protocol'}}">
                            <p>如何获得恐龙蛋?</p>
                        </router-link>
                    </div>
                </div>
                <div v-if="type === 2"> <!--成为认证设计师-->
                    <div class="title reginerTitle">
                        住逻辑设计师认证
                    </div>
                    <div class="imgCon">
                        <img src="../../images/egg/egg-l.png" alt="">
                    </div>
                    <div class="button">
                        <router-link :to="{name: 'myRecharge'}">
                            <span>立即购买</span>
                        </router-link>
                        <router-link :to="{name: 'myQuestionDetail',params:{code:'egg-protocol'}}">
                            <p>如何获得恐龙蛋?</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="egglack regineeEgglack reginerGO" v-if="type === 2"> <!--立即认证-->
                <div class="title reginerTitle">
                    住逻辑设计师认证
                </div>
                <div class="imgCon">
                      <span class="img">
                          <img src="../../images/reginerBanner.png" alt="">
                      </span>
                </div>
                <div class="button classSpacie">
                    <router-link :to="{name: 'myAuthentication'}">
                        <span @click="toReginer">立即认证</span>
                    </router-link>
                    <div>
                        <span @click="skipData">跳过</span>
                    </div>
                </div>
            </div>


            <div class="egglack errAuthentication" v-if="type === 3"> <!--没有权限-->
                <div class="imgCon">
                <span class="img">
                    <img src="../../images/egg/err.png" alt="">
                </span>
                </div>
                <div class="title">
                    你还不是住逻辑认证设计师，无法使用该功能
                </div>
                <div class="button" @click="toReginer">
                    <span>立即认证</span>
                </div>
            </div>

            <div class="egglack adopt" v-if="type === 4 && user"> <!--认证设计师通过-->
                <div class="title">
                    {{text}}
                </div>
                <div class="imgCon">
                  <span class="img">
                      <img v-if="user.avatarFile" :src="imgBaseUrl + user.avatarFile.key" alt="">
                  </span>
                </div>
                <div class="num">
                    <span v-if="user.loginName">{{user.loginName}}</span>
                    <span v-else>{{user.phone}}</span>
                    <p>
                    <span>
                        <img src="../../images/egg/adopt.png" alt="">
                    </span>
                        认证设计师
                    </p>
                </div>
                <div class="button">
                    <span @click="adopt">立即体验</span>
                </div>
            </div>
        </Modal>
    </div>

</template>

<script>
    import store from '../../store'
    import api from '../../api'
    export default {
        data () {
            return {
                modal1: false,
                skipType: 1,
                imgBaseUrl: api.common.imgBaseUrl,
                parentsNext: null
            }
        },
        props: {
            text: {
                type: String
            },
            type:{
                type: Number
            }
        },
        methods: {
            open(parents){
                if(parents){
                    this.parentsNext = parents
                }
                this.modal1 = true
            },
            skipData(){
               this.cancel()
            },
            adopt() {
                this.cancel()
            },
            toReginer(){
                this.cancel()
                this.$router.push({path: '/my/personal/accountSetting'})
            },
            cancel(cellData){
                //请求接口
                api.account.hasRead()
                    .then(res => {
                        if(res){
                            this.modal1 = false
                        }
                    })
            }
        },
        computed: {
            balance() {
                return this.$store.state.app.balance
            },
            user() {
                return this.$store.state.user.info
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    #egglack .ivu-icon-ios-close-empty {
        top: -8px;
        font-size: 40px !important;
    }
    .egglack{
        width: 100%;
        padding: 60px 20px;
        .title{
            width: 100%;
            text-align: center;
            font-size: 20px;
            color: #E14B5D;
        }
        .reginerTitle{
            font-size: 24px;
            color: #353838;
        }
        .imgCon{
            margin-top: 44px;
            width: 100%;
            text-align: center;
            .img{
                display: inline-block;
                width: 120px;
                /*height: 114px;*/
                img{
                    width: 100%;
                }
            }
        }
        .num{
            width: 100%;
            font-size: 32px;
            color: #308697;
            margin-top: 26px;
        }
        .button, .classSpacie{
            width: 100%;
            margin-top: 32px;
            text-align: center;
            span{
                color:#fff;
                font-size: 14px;
                background: #E14B5D;
                padding: 9px 45px;
                border-radius: 4px;
                cursor: pointer;
            }
            p{
                width: 100%;
                text-align: center;
                font-size: 12px;
                color: #6C6F70;
                margin-top: 10px;
                text-decoration: underline;
                cursor: pointer;
            }
            >div{
                margin-top: 50px;
                span{
                    width: 100%;
                    text-align: center;
                    font-size: 12px;
                    padding: 0;
                    background: none;
                    color: #6C6F70;
                    margin-top: 10px;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
    }
    .regineeEgglack{
        padding-left:0 ;
        padding-right: 0px;
        .imgCon{
            margin-top: 44px;
            width: 100%;
            text-align: center;
            img{
                width: 100%;
            }
        }
        .button{
            width: 100%;
            margin-top: 41px;
            text-align: center;
            span{
                color:#fff;
                font-size: 14px;
                background: #99C72C;
                padding: 9px 92px;
                border-radius: 4px;
                cursor: pointer;
            }
            p{
                width: 100%;
                text-align: center;
                font-size: 12px;
                color: #308697;
                margin-top: 26px;
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }
    .errAuthentication{
        .imgCon{
            .img{
                width: 360px;
                margin: 0 auto;
            }
        }
        .title{
            font-size: 18px;
            color: #E14B5D;
            margin-top: 20px;
        }
        .button{
            margin-top: 100px;
            span{
                padding-left: 90px;
                padding-right: 90px;
                background: #99C72C;
            }
        }
    }
    .adopt{
        .imgCon{
            text-align: center;
            .img{
                width: 180px;
                height: 180px;
                border-radius: 50%;
                overflow: hidden;
                img{
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                }
            }
        }
        .num{
            margin-top: 20px;
            >span{
                font-size: 28px;
                color:#000;
            }
            >p{
                font-size: 18px;
                color: #6C6F70;
                vertical-align: middle;
                width: 100%;
                text-align: center;
                margin-top: 20px;
                line-height: 30px;
                >span{
                    vertical-align: middle;
                    display: inline-block;
                    width: 25px;
                    img{
                        width: 100%;
                        vertical-align: middle;
                    }
                }
            }
        }
        .button{
            margin-top:40px;
            span{
                padding-right: 90px;
                padding-left: 90px;
                background: #99C72C;
            }
        }
    }
    .reginerGO{
        .imgCon{
            .img{
                width: 100%;
            }
        }
    }
    @media screen and (max-width: 1799px){
        .egglack{
            padding: 40px 20px;
        }
        .reginerGO{
            .imgCon{
                .img{
                    height: 260px;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
        .regineeEgglack .imgCon{
            margin-top: 15px;
        }
    }
</style>